import { QueryClient } from '@tanstack/react-query';

/**
 * Refetches the page detail queries (`['pages', id, fields]`) — of one page, or
 * of every page when `pageId` is omitted — without touching the chat-message
 * queries that share the `['pages', id]` prefix: those must never be refetched
 * mid-stream (it would clobber the messages being streamed into local state).
 */
export const invalidatePageQueries = (queryClient: QueryClient, pageId?: string) =>
  queryClient.invalidateQueries({
    predicate: (query) =>
      query.queryKey[0] === 'pages' &&
      (pageId === undefined || query.queryKey[1] === pageId) &&
      query.queryKey[2] !== 'chat-agent-messages',
  });
